import { render, staticRenderFns } from "./ListaMudancasHorarios.vue?vue&type=template&id=048c0531&"
import script from "./ListaMudancasHorarios.vue?vue&type=script&lang=js&"
export * from "./ListaMudancasHorarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports